import { ShortSegLine } from "./ShortSegLine";
import { LongSegLine } from "./LongSegLine";
/** 弹幕时间轴 */
var Timeline = /** @class */ (function () {
    function Timeline() {
        this.shortSegLine = new ShortSegLine();
        this.longSegLine = new LongSegLine();
    }
    /** 获取下一秒段的弹幕数据 */
    Timeline.prototype.getNextList = function (s) {
        return this.shortSegLine.getSegList(s + 1); // 在到达s秒的时候提前获取s+1秒段的弹幕，是为了减少命令执行延迟带来的影响
    };
    /** 获取seek后的弹幕数据
     * 包括当前秒段及下一秒段弹幕、该秒段前60秒段所有未结束弹幕、当前长段未结束弹幕 */
    Timeline.prototype.getSeekList = function (time) {
        var s = Math.floor(time / 1000);
        var currentSeg = this.shortSegLine.getSegList(s);
        var nextSeg = this.shortSegLine.getSegList(s + 1);
        var beforeDanmakuList = this.getBeforeDanmaku(time);
        var longDanmakuList = this.getLongDanmaku(time);
        var list = [];
        list = list.concat(longDanmakuList, beforeDanmakuList, currentSeg, nextSeg);
        return list;
    };
    /** 获取该秒段之前60个秒段的未结束弹幕数据 */
    Timeline.prototype.getBeforeDanmaku = function (time) {
        var s = Math.floor(time / 1000);
        var list = [];
        for (var t = s < 60 ? 0 : s - 60; t < s; t++) {
            var seg = this.shortSegLine.list[t];
            seg === null || seg === void 0 ? void 0 : seg.forEach(function (dan) {
                if (dan.end > time) {
                    list.push(dan);
                }
            });
        }
        return list;
    };
    /** 获取该长段中未结束弹幕(开始时间早于所在时间秒段的60个秒段之前) */
    Timeline.prototype.getLongDanmaku = function (time) {
        var s = Math.floor(time / 1000);
        var m = Math.floor(time / 60000);
        var list = [];
        var seg = this.longSegLine.list[m];
        seg === null || seg === void 0 ? void 0 : seg.forEach(function (dan) {
            if (dan.start < (s - 60) * 1000 && dan.end > time) {
                list.push(dan);
            }
        });
        return list;
    };
    /** 清空时间轴 */
    Timeline.prototype.clear = function () {
        this.shortSegLine.clear();
        this.longSegLine.clear();
    };
    /** 添加弹幕到时间轴 */
    Timeline.prototype.add = function (dan) {
        this.shortSegLine.add(dan);
        // 如果时间大于60s=60000ms, 则算作长弹幕, 加入长段时间轴中
        if (dan.duration > 60000) {
            this.longSegLine.add(dan);
        }
    };
    /** 移除时间轴上的某条弹幕 */
    Timeline.prototype.remove = function (dan) {
        this.shortSegLine.remove(dan);
        if (dan.duration > 60000) {
            this.longSegLine.remove(dan);
        }
    };
    return Timeline;
}());
export { Timeline };
//# sourceMappingURL=Timeline.js.map